export default __webpack_public_path__ + "static/media/failure-indicator-icon.20c3a6e0.svg";